import { apiClient } from "@/context/AuthContext";

export const getPosition = (timeout = 10000) => new Promise((resolve) => {
  if (!navigator.geolocation) return resolve(null);
  navigator.geolocation.getCurrentPosition(
    (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
    () => resolve(null),
    { enableHighAccuracy: true, timeout, maximumAge: 30000 },
  );
});

export const uploadGeoEvidence = async (findingId, file, geo, note = "") => {
  const form = new FormData();
  form.append("file", file);
  const params = { source: "camera", captured_at: new Date().toISOString(), note };
  if (geo) Object.assign(params, { lat: geo.lat, lng: geo.lng, accuracy: Math.round(geo.accuracy || 0) });
  const { data } = await apiClient.post(`/findings/${findingId}/evidence`, form, { params });
  return data;
};

export const mapsUrl = (geo) => `https://www.google.com/maps?q=${geo.lat},${geo.lng}`;
